// Paths that don't need the legacy GSC app bootstrap. These get the lightweight
// `/api/auth/user/?source=verify` response; everything else (the old GSC app
// under `/*`) gets the full one with GSC properties and chat_state.
const LIGHT_AUTH_PREFIXES = [
  '/verify',
  '/sites',
  '/site/',
  '/account',
  '/home',
  '/search-console',
  '/login',
  '/signup',
  '/answer-engine',
  '/davegpt',
  '/subscription/success',
];

export const isLightAuthPath = (path) =>
  path === '/' || (!!path && LIGHT_AUTH_PREFIXES.some(prefix => path.startsWith(prefix)));

export const userDetailsEndpoint = (path) =>
  isLightAuthPath(path) ? '/api/auth/user/?source=verify' : '/api/auth/user/';
